// @flow

import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Color, flex, hoverChild, absolute, Transition, h15, hover } from 'styles';
import { Link } from 'components/Gui';
import { useNavDispatch, NavContextActions } from 'contexts';

const Wrapper = styled.div`
  position: relative;
  min-height: 72px;
  ${flex('flex-start', 'flex-start')};
  flex-direction: column;

  a {
    line-height: 1;
    letter-spacing: 0.025em;
    margin-bottom: 0;
    height: 72px;
    ${flex('flex-start', 'center')};
    ${hover('color', Color.BLACK_SOUL, Color.MARKETS_RED)};
  }

  a.child {
    text-indent: 20px;
  }

  > div.title {
    line-height: 1;
    letter-spacing: 0.025em;
    margin-bottom: 0;
    height: 72px;
    ${flex('flex-start', 'center')};
  }

  button {
    width: 38px;
    height: 38px;
    ${flex()};
    ${hoverChild('path', 'stroke', Color.GREY_FOUR, Color.BLACK_SOUL)};
    transform-origin: 50% 50% 0;
    transition: transform ${Transition.DEFAULT_MOBILE};
    transform: rotateX(${({ showing }) => (showing ? '180deg' : 0)});

    path {
      ${({ showing }) => showing && `stroke: ${Color.BLACK_SOUL} !important`};
    }
  }
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: ${Color.BLURPLE_LIGHT};
`;

const MenuGroup = ({
  data: { title, url, children },
}: {
  data: { title: string, url: string, children?: { links: { title: string, url: string }[] } },
}) => {
  const dispatch = useNavDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = useCallback(() => {
    dispatch({
      type: NavContextActions.TOGGLE_MOBILE_NAV,
      payload: {
        pageToTop: true,
      },
    });
  }, [dispatch]);
  return (
    <>
      <Wrapper showing={isOpen}>
        {!children && (
          <Link url={url} onClick={closeMenu}>
            {title}
          </Link>
        )}
        {children && (
          <>
            <Link url={url} onClick={closeMenu}>
              {title}
            </Link>
            {children.links.map(({ title, url }) => (
              <Link className="child" url={url} onClick={closeMenu}>
                {title}
              </Link>
            ))}
          </>
        )}
      </Wrapper>
      <Line />
    </>
  );
};

export default MenuGroup;
